<template>
    <div>
        
        <Header />
        <TitlePage />
        <b-container>
            <b-img :src="`/images/activities/banner.jpg`" fluid alt="Responsive image"></b-img>
            <b-row class="my-4">
                <b-col cols="12"  class="py-2"><h5>Merry Christmas & Happy New Year รับของขวัญจากซานต้า</h5></b-col>
                <b-col cols="12"  class="py-2"><p>ไทยรัฐซื้อขาย แจก Coin ฟรี 550 บาท! 100 สิทธิ์เท่านั้น มูลค่ารวม 55,000 บาท สำหรับสมาชิกใหม่!</p></b-col>
            </b-row>
            <b-row class="my-5" align-content="center" >
                <b-col cols="12" md="3" class="text-center">
                    <b-img left   :src="`/images/activities/1.png`" width="200" alt="Responsive image"></b-img>
                </b-col>
                <b-col cols="12" md="6" class="py-2"><h5>กติกาเข้าร่วมกิจกรรมง่าย ๆ เพียง</h5>
                <p>1. กดสมัครสมาชิกผ่านทางเว็บไทยรัฐ ซื้อ-ขาย ระยะเวลาตั้งแต่วันที่ 24 ธ.ค. – 10 ม.ค. 2564</p>
                </b-col>
            </b-row>
            <b-row class="my-5" align-content="center">
                <b-col cols="12" md="3" class="text-center">
                    <b-img left   :src="`/images/activities/2.png`" width="200" alt="Responsive image"></b-img>
                </b-col>
                <b-col cols="12" md="6" class="py-5"><p>2. กรอกข้อมูลรายละเอียดต่าง ๆ ตามแบบฟอร์มที่กำหนดให้</p>
                </b-col>
            </b-row>
            <b-row class="my-5" align-content="center">
                <b-col cols="12" md="3" class="text-center">
                    <b-img left   :src="`/images/activities/3.png`" width="200" alt="Responsive image"></b-img>
                </b-col>
                <b-col cols="12" md="6" class="py-3"><p>3. ยืนยันอีเมลที่ใช้ในการสมัคร</p>
                </b-col>
            </b-row>
            <b-row class="my-5" align-content="center">
                <b-col cols="12" md="3" class="text-center">
                    <b-img left   :src="`/images/activities/4.png`" width="200" alt="Responsive image"></b-img>
                </b-col>
                <b-col cols="12" md="6" class="py-5">
                    <p>4. Capture ภาพหน้าจอ พร้อมส่งมาที่อีเมล support@thairathclassifieds.com </p>
                    <p class="py-4">หรือ ผ่านช่องทาง Facebook ไทยรัฐซื้อขาย <a href="https://www.facebook.com/thairath.classifieds">https://www.facebook.com/thairath.classifieds</a>
                    </p>
                </b-col>
            </b-row>
            <b-row class="my-5" align-content="center" style="margin-top:80px!important">
                <b-col cols="12" md="3" class="text-center">
                    <b-img center   :src="`/images/activities/5.png`" width="100" alt="Responsive image"></b-img>
                </b-col>
                <b-col cols="12" md="6" class="py-3">
                    
                    <p>5. รอรับโค้ดรหัส Coin ของคุณเพื่อนำไปเติมในบัญชีของคุณ ได้เลย (วิธีกchange color of linkารซื้อ Coin หรือใช้โค้ดส่วนลดเพื่อซื้อ Coin) </p>
                    <p>
                    <router-link
                    id="faq-how-to-post-listing"
                     :to="{path:$i18nRoute({ name: 'ads'}) ,query:{selected:3}}"
                    target="_blank"
                    style="color:blue"
                    >· วิธีการซื้อ Coin</router-link
                  >
                    </p>
                    <p>
                    <router-link
                    id="faq-how-to-post-listing"
                    :to="$i18nRoute({ name: 'topics/how-to-post-listing' })"
                    target="_blank"
                    style="color:blue"
                    >· ใช้โค้ดส่วนลดเพื่อซื้อ Coin</router-link
                  >
                    </p>
                </b-col>
            </b-row>
        </b-container>
        <Footer :adsFooter="adsFooter"/>
    </div>
</template>
<script>
import Header from "@/components/ui/header";
import TitlePage from "@/components/ui/titlePage";
import Footer from "@/components/ui/footer";
export default {
    name:'Activities',
    components: {
		Header,
		TitlePage,
        Footer,
	},
	data() {
		return {
			adsFooter: null,
		};
    },
    
}
</script>
<style lang="scss">

</style>